import { TypedDocumentNode, gql } from '@apollo/client';
import { Location } from 'types';

const locationNodes = `
  location
  locationType
  postcode
  latitude
  longitude
  numSettled
  avgAmountSettled
  amountSettled
  annualEnergyGeneratedGigawatthours
  avgTotalPanelsCapacityKilowatt
  sumTotalPanelsCapacityKilowatt
  numDistinctAddressSettled
  numSettledAllSolar
  numSettledAllBatteries
  numSettledAllElectricVehicles
  numSettledBatteries
  numSettledSolarSystem
  numSettledSolarSystemAndBatteryCombo
  numSettledSolarInverters
  numSettledSolarPoolHeatingSystems
  numSettledSolarPanels
  numSettledSolar
  numSettledBatteryStorage
  numSettledSolarAndBatterySystem
  numSettledAirConditioningAndVentilation
  numSettledEvChargingInfrastructure
  numSettledEfficientElectricStoveTops
  numSettledElectricHeatingAndCoolingSystemsReverseCycle
  numSettledHotWaterHeatPumpsHwhp
  numSettledElectricVehicles
  numSettledElectricCarNew
  numSettledElectricCarUsed
  numSettledHydronicHeatPumps
  numSettledInsulation
  numSettledElectricMotorbikeNew
  numSettledElectricMotorbikeUsed
  lastUpdatedAt
`;

interface LocationsQuery {
  allActPublicLocationLevels: {
    nodes: Location[];
  };
}

export const GET_LOCATIONS_QUERY: TypedDocumentNode<LocationsQuery> = gql`
  query AllActPublicLocationLevels {
    allActPublicLocationLevels {
      nodes {
        ${locationNodes}
      }
    }
  }
`;
